<template>
    <Layout sub-title="Account" back-page-name="account" title="Receipts" active="account" :hide-logout="true">

        <div class="container">
            <div class="columns">
                <div class="column">
                    <Loading :loading="loading">
                        <table class="table falcon-table">
                            <thead>
                            <tr>
                                <th>
                                    Date
                                </th>
                                <th>
                                    Reference
                                </th>
                                <th>
                                    Term
                                </th>
                                <th>
                                    Plan
                                </th>
                                <th>
                                    Price
                                </th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="invoice in invoices">
                                <td>
                                    {{invoice.created | moment("YYYY-MM-DD") }}
                                </td>
                                <td>
                                    {{invoice.id}}
                                </td>
                                <td>
                                    {{invoice.plan.interval}}
                                </td>
                                <td>
                                    {{invoice.plan.label}}
                                </td>
                                <td>
                                    ${{invoice.total}}
                                </td>
                                <td>
                                    <a  href="#" @click="downloadReport(invoice)">Download</a>
                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </Loading>
                </div>
            </div>
        </div>

    </Layout>


</template>

<script>
    import Layout from "../../../shared/components/Layout";
    import Loading from "../../../shared/components/Loading";
    import {PaymentAPI} from "../../../apis/PaymentAPI";

    export default {
        name: "Receipts.vue",
        data() {
            return {
                invoices: [],
                loading: false
            }
        },
        components: {Layout, Loading},
        async mounted() {
            this.loading = true;
            let resp = await PaymentAPI.listInvoices();
            this.invoices = resp.invoices;
            this.loading = false;
        },
        props: ['hideLogout'],
        methods: {
          downloadReport(invoice) {
            window.open(invoice.invoice_pdf, '_blank');
            SFAnalytics.track('Receipt Download', invoice.id);
          }
        },
        computed: {}
    }
</script>

<style scoped lang="scss">
    .credit-info, .renew-info {
        color: #7C828A;
        font-size: 20px;
        font-family: "Lota Grotesque Regular", sans-serif;
    }

</style>
